import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { tiktokPostSelector } from 'services/compose/selectors'
import styles from './TikTokPhotoPostCaption.pcss'
import { useIntl } from 'react-intl'
import { TIKTOK_PHOTO_DESCRIPTION_MAX_LENGTH, TIKTOK_PHOTO_TITLE_MAX_LENGTH } from 'shared'
import { setTiktokPhotoDescription, setTiktokPhotoTitle } from 'services/compose'
import { DebouncedTextField } from 'components/DebouncedTextField'

export function TikTokPhotoPostCaption() {
  const intl = useIntl()
  const dispatch = useDispatch()
  const { title, description } = useSelector(tiktokPostSelector)

  const onTitleChange = (value: string) => {
    dispatch(setTiktokPhotoTitle(value))
  }

  const onDescriptionChange = (value: string) => {
    dispatch(setTiktokPhotoDescription(value))
  }

  return (
    <div className={styles.container}>
      <DebouncedTextField
        value={title}
        maxLength={TIKTOK_PHOTO_TITLE_MAX_LENGTH}
        showRemainingCharsBelow={51}
        placeholder={intl.formatMessage({ id: 'composer.labels.tiktok-title-placeholder' })}
        classes={{ root: styles['title-box'] }}
        FormHelperTextProps={{ className: styles.helper }}
        onTextChange={onTitleChange}
      />
      <DebouncedTextField
        value={description}
        multiline
        maxLength={TIKTOK_PHOTO_DESCRIPTION_MAX_LENGTH}
        showRemainingCharsBelow={51}
        placeholder={intl.formatMessage({ id: 'composer.labels.tiktok-text-placeholder' })}
        className={styles['description-box']}
        classes={{ root: styles['description-input'] }}
        FormHelperTextProps={{ className: styles.helper }}
        onTextChange={onDescriptionChange}
      />
    </div>
  )
}
